export enum TrainingMethodsPreviewMode {
    PREVIEW = 'preview',
    INLINE = 'inline',
    SELECT = 'select',
}
